module.exports = __webpack_public_path__ + "static/DC0-abc2407b328b35c803cc8a896874cac7.jpg";